import React from 'react';
import './About.css';

function AboutJason() {
  return (
    <section className="about" id="cofounder-jason">
      <div className="about-inner">
        <h2 className="section-title">Jason Alba, MBA, DBA</h2>

        <div className="about-layout">
          <div className="about-photo reveal">
            <img src="/assets/jason-headshot.png" alt="Jason Alba" />
            <div className="about-title-box">
              <span>Co-Founder</span>
              <span className="divider">|</span>
              <span>Director</span>
              <span className="divider">|</span>
              <span>Business Strategy</span>
              <span className="divider">|</span>
              <span>Governance</span>
            </div>
          </div>

          <div className="about-text reveal delay-1">

            <p className="lead">
              Jason Alba co-founded Nexus Concordat and serves on the Board
              of Directors. He brings over twenty years of pharma regulatory
              operations experience and his work as founder of EvoSynapse
              AI to the governance of the parent holding company.
            </p>

            <p>
              His long-range planning discipline and the structural
              decisions he partners on with the founding team are what
              protect the integrity of the patent portfolio and keep the
              parent company sovereign. Nexus Concordat's closed cap table
              is a governance choice as much as a capital choice, and
              Jason is one of the two Class A holders whose alignment
              makes that closure durable.
            </p>

            <p>
              At EvoSynapse AI, Jason built the operational patterns for
              regulatory-adjacent AI infrastructure. That experience
              carries into how Nexus Concordat's healthcare arm approaches
              the FDA lane, and how the non-healthcare subsidiary structures
              its commercial products.
            </p>

            <div className="about-credentials">
              <div className="credential-item">
                <span className="credential-label">Role</span>
                <span className="credential-value">Co-Founder &amp; Director</span>
              </div>
              <div className="credential-item">
                <span className="credential-label">Prior Founding</span>
                <span className="credential-value">EvoSynapse AI &mdash; Founder</span>
              </div>
              <div className="credential-item">
                <span className="credential-label">Industry Experience</span>
                <span className="credential-value">20+ Years Pharma Regulatory Operations</span>
              </div>
              <div className="credential-item">
                <span className="credential-label">Focus</span>
                <span className="credential-value">Business Strategy &mdash; Governance &mdash; Cap Table Sovereignty</span>
              </div>
            </div>

            <blockquote>
              "A closed cap table is not a limitation. It is the guarantee
              that the substrate stays with the people who built it."
            </blockquote>

          </div>
        </div>

      </div>
    </section>
  );
}

export default AboutJason;
